import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  FaChevronDown, FaChevronUp, FaPills, FaUserMd, FaDollarSign,
  FaClipboardCheck, FaHeartbeat, FaShieldAlt, FaQuestionCircle,
  FaArrowRight, FaClock, FaWeight
} from 'react-icons/fa';
import images from '../assets/images';
import SEO, { PageSEO, StructuredData } from '../components/SEO';

const FAQ = () => {
  const [openItems, setOpenItems] = useState({});

  const toggleItem = (categoryIndex, itemIndex) => {
    const key = `${categoryIndex}-${itemIndex}`;
    setOpenItems(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const isOpen = (categoryIndex, itemIndex) => {
    return openItems[`${categoryIndex}-${itemIndex}`] || false;
  };

  const faqCategories = [
    {
      title: 'Program & Coaching',
      icon: FaHeartbeat,
      color: 'success',
      questions: [
        {
          q: 'What is included in the Fitnession Core program?',
          a: 'Our Core program includes: personalized meal plans tailored to your preferences and goals, custom workout programs for your fitness level, 1:1 health coaching with certified coaches, progress tracking tools, nutrition guidance, weekly check-ins, email and chat support, and lifestyle coaching for sustainable habit building.'
        },
        {
          q: 'How does the coaching work?',
          a: 'You will be paired with a dedicated certified health coach who provides weekly check-ins, accountability support, and personalized guidance. You can message your coach anytime through our app for quick questions and motivation. Our Six Pillars approach covers nutrition, exercise, sleep, mental health, lifestyle habits, and medical support when needed.'
        },
        {
          q: 'What lifestyle coaching is provided?',
          a: 'Our comprehensive coaching covers: (1) Personalized nutrition and meal planning, (2) Custom exercise programming, (3) Sleep optimization strategies, (4) Mental health and behavioral support, (5) Lifestyle habit building, and (6) Medical support including GLP-1 for eligible members. You will work with certified coaches who provide accountability and ongoing support.'
        },
        {
          q: 'Do I need to follow a specific diet?',
          a: 'We do not prescribe a rigid diet plan. Instead, our nutrition coaches work with you to develop sustainable eating habits that fit your lifestyle, preferences, and cultural background. We emphasize protein-rich foods, vegetables, whole grains, and mindful eating. You will learn to make better choices without feeling deprived.'
        },
        {
          q: 'What if I have dietary restrictions or food allergies?',
          a: 'Our nutrition guidance is fully customizable. Whether you are vegetarian, vegan, gluten-free, kosher, halal, or have food allergies, our coaches will work with you to create a plan that meets your needs while supporting your weight loss goals.'
        }
      ]
    },
    // {
    //   title: 'GLP-1 Medications',
    //   icon: FaPills,
    //   color: 'primary',
    //   questions: [
    //     {
    //       q: 'What are GLP-1 medications?',
    //       a: 'GLP-1 (Glucagon-Like Peptide-1) medications are FDA-approved injectable drugs that mimic a natural hormone in your body. They work by regulating appetite, slowing gastric emptying, and improving insulin sensitivity. Common GLP-1 medications include Semaglutide (Ozempic, Wegovy), Tirzepatide (Mounjaro, Zepbound), and Liraglutide (Saxenda).'
    //     },
    //     {
    //       q: 'How do GLP-1 medications help with weight loss?',
    //       a: 'GLP-1 medications work through multiple mechanisms: they reduce appetite by acting on hunger centers in the brain, slow down stomach emptying so you feel full longer, improve blood sugar control, and reduce cravings. Clinical trials have shown average weight loss of 15-20% of body weight over 68 weeks when combined with lifestyle changes.'
    //     },
    //     {
    //       q: 'Are GLP-1 medications safe?',
    //       a: 'Yes, GLP-1 medications are FDA-approved and have been extensively studied in clinical trials involving thousands of participants. Like all medications, they can have side effects, but most are mild and temporary. Our medical team monitors your progress closely and adjusts treatment as needed to ensure safety and effectiveness.'
    //     },
    //     {
    //       q: 'How long do I need to take GLP-1 medications?',
    //       a: 'The duration varies by individual. Many patients use GLP-1 medications for 12-24 months while building sustainable lifestyle habits. Some may benefit from longer-term use. Our providers work with you to create a personalized plan, and our comprehensive lifestyle coaching helps you maintain results even after discontinuing medication.'
    //     },
    //     {
    //       q: 'What is the difference between Semaglutide and Tirzepatide?',
    //       a: 'Both are effective GLP-1 medications, but they work slightly differently. Semaglutide (Wegovy/Ozempic) targets GLP-1 receptors only, while Tirzepatide (Mounjaro/Zepbound) targets both GLP-1 and GIP receptors, potentially offering enhanced weight loss. Clinical trials showed Tirzepatide resulted in up to 22.5% weight loss vs 15% for Semaglutide. Your provider will recommend the best option for you.'
    //     },
    //     {
    //       q: 'Can I take GLP-1 medications with other medications?',
    //       a: 'GLP-1 medications can interact with certain drugs, especially those for diabetes, blood thinners, and some oral medications whose absorption may be affected. During your consultation, our providers will review all your current medications to ensure safe co-administration and make necessary adjustments.'
    //     }
    //   ]
    // },
    // {
    //   title: 'Eligibility & Getting Started',
    //   icon: FaClipboardCheck,
    //   color: 'accent',
    //   questions: [
    //     {
    //       q: 'Who is eligible for the Fitnession program?',
    //       a: 'You may be eligible if you have a BMI of 30 or higher (obesity), or a BMI of 27 or higher with at least one weight-related health condition such as type 2 diabetes, high blood pressure, high cholesterol, sleep apnea, or PCOS. You must be 18 years or older and not have certain medical contraindications.'
    //     },
    //     {
    //       q: 'What conditions would disqualify me from the program?',
    //       a: 'Certain conditions are contraindications for GLP-1 medications, including: personal or family history of medullary thyroid carcinoma (MTC), Multiple Endocrine Neoplasia syndrome type 2 (MEN 2), history of pancreatitis, current pregnancy or breastfeeding, type 1 diabetes, and active eating disorders. Our assessment will screen for these conditions.'
    //     },
    //     {
    //       q: 'How do I know if I am eligible?',
    //       a: 'Simply complete our free online health assessment. It takes about 5 minutes and asks about your health history, current medications, and weight loss goals. You will receive your eligibility result immediately, and if qualified, you can schedule a consultation with one of our licensed providers.'
    //     },
    //     {
    //       q: 'What happens after I complete the assessment?',
    //       a: 'If you are eligible, you will be prompted to schedule a virtual consultation with a licensed healthcare provider. During this consultation, they will review your health history, discuss treatment options, answer your questions, and if appropriate, prescribe medication. Your medication is then shipped directly to your door.'
    //     },
    //     {
    //       q: 'Do I need to have tried other weight loss methods first?',
    //       a: 'While prior attempts at weight loss through diet and exercise are common among our members, they are not strictly required for eligibility. Our providers will assess your individual situation and determine if GLP-1 medication is appropriate for you based on medical criteria.'
    //     }
    //   ]
    // },
    // {
    //   title: 'Program & Treatment',
    //   icon: FaHeartbeat,
    //   color: 'success',
    //   questions: [
    //     {
    //       q: 'What is included in the Fitnession program?',
    //       a: 'Our comprehensive program includes: virtual consultations with licensed healthcare providers, FDA-approved GLP-1 medication (if prescribed), personalized nutrition guidance, exercise recommendations tailored to your fitness level, sleep optimization strategies, mental health support, ongoing health coaching, progress tracking tools, and 24/7 messaging support with your care team.'
    //     },
    //     {
    //       q: 'How are the medications administered?',
    //       a: 'GLP-1 medications are self-administered via a small injection, typically once weekly. The injection is given subcutaneously (under the skin) in the abdomen, thigh, or upper arm. The needles are very thin (similar to insulin needles), and most patients report minimal discomfort. We provide detailed instructions and support for your first injection.'
    //     },
    //     {
    //       q: 'How often will I have consultations with a provider?',
    //       a: 'You will have an initial consultation to start treatment, followed by regular check-ins. Most patients have follow-up consultations monthly for the first 3 months, then every 2-3 months thereafter. You can also request additional consultations anytime and have unlimited messaging access to your care team.'
    //     },
    //     {
    //       q: 'What lifestyle coaching is provided?',
    //       a: 'Our Six Pillars approach covers: (1) GLP-1 Medication management, (2) Personalized exercise programming, (3) Nutrition guidance with meal plans and recipes, (4) Sleep optimization strategies, (5) Mental health and behavioral support, and (6) Lifestyle habit building. You will work with certified coaches who provide accountability and support.'
    //     },
    //     {
    //       q: 'Can I continue seeing my regular doctor while on this program?',
    //       a: 'Absolutely! We encourage you to maintain your relationship with your primary care physician. We can coordinate care and share relevant health information with your doctor (with your consent). Our program is designed to complement, not replace, your existing healthcare.'
    //     }
    //   ]
    // },
    // {
    //   title: 'Results & Expectations',
    //   icon: FaWeight,
    //   color: 'primary',
    //   questions: [
    //     {
    //       q: 'How much weight can I expect to lose?',
    //       a: 'Results vary by individual, but clinical trials show average weight loss of 15-22% of body weight over 68 weeks with GLP-1 medications combined with lifestyle changes. Many Fitnession members see 5-10% weight loss within the first 3 months. Factors affecting results include medication type, dosage, adherence to lifestyle changes, and individual metabolism.'
    //     },
    //     {
    //       q: 'How soon will I see results?',
    //       a: 'Most patients notice reduced appetite and early weight loss within the first 2-4 weeks. Significant weight loss typically becomes visible by 8-12 weeks. The medication dosage is gradually increased over time to minimize side effects and optimize results. Maximum results are usually seen between 12-18 months.'
    //     },
    //     {
    //       q: 'Will I regain weight after stopping the medication?',
    //       a: 'Weight regain is possible if healthy habits are not maintained. This is why Fitnession focuses on comprehensive lifestyle coaching alongside medication. Our program helps you build sustainable habits in nutrition, exercise, sleep, and stress management so you can maintain your results long-term. Some patients may benefit from continued low-dose maintenance therapy.'
    //     },
    //     {
    //       q: 'What other health benefits can I expect?',
    //       a: 'Beyond weight loss, GLP-1 medications have been shown to improve blood sugar control, reduce blood pressure, improve cholesterol levels, decrease inflammation, reduce risk of cardiovascular events, improve sleep apnea symptoms, reduce fatty liver, and improve PCOS symptoms. Many patients also report improved energy, mood, and overall quality of life.'
    //     },
    //     {
    //       q: 'What if the medication does not work for me?',
    //       a: 'Response to GLP-1 medications varies. If you are not seeing expected results, our providers may adjust your dosage, try a different medication (e.g., switching from Semaglutide to Tirzepatide), or explore other factors affecting your progress. We are committed to finding what works for you and offer a satisfaction guarantee.'
    //     }
    //   ]
    // },
    // {
    //   title: 'Side Effects & Safety',
    //   icon: FaShieldAlt,
    //   color: 'accent',
    //   questions: [
    //     {
    //       q: 'What are the common side effects of GLP-1 medications?',
    //       a: 'The most common side effects are gastrointestinal and usually temporary: nausea (20-40% of patients), vomiting, diarrhea, constipation, and decreased appetite. These typically improve within the first few weeks as your body adjusts. Starting with a low dose and gradually increasing helps minimize these effects.'
    //     },
    //     {
    //       q: 'How can I manage nausea and other side effects?',
    //       a: 'Tips for managing GI side effects include: eating smaller, more frequent meals; avoiding fatty, greasy, or spicy foods; staying hydrated; eating slowly; not lying down immediately after eating; and taking the medication at bedtime. Our care team provides personalized guidance and can prescribe anti-nausea medication if needed.'
    //     },
    //     {
    //       q: 'Are there serious side effects I should know about?',
    //       a: 'Rare but serious side effects include pancreatitis (severe abdominal pain), gallbladder problems, kidney issues, and allergic reactions. There is also a warning about thyroid tumors based on animal studies, though this has not been confirmed in humans. Our providers screen for risk factors and monitor you throughout treatment. Seek immediate care if you experience severe symptoms.'
    //     },
    //     {
    //       q: 'Can GLP-1 medications cause muscle loss?',
    //       a: 'Rapid weight loss from any method can result in some muscle loss. This is why Fitnession emphasizes protein-rich nutrition (we recommend 0.8-1g protein per pound of goal body weight) and strength training as part of our program. Studies show that combining GLP-1 medications with resistance exercise and adequate protein intake preserves muscle mass during weight loss.'
    //     },
    //     {
    //       q: 'Is it safe to exercise while taking GLP-1 medications?',
    //       a: 'Yes, exercise is encouraged and beneficial! Start slowly if you are new to exercise, stay hydrated, and listen to your body. Some patients may experience low blood sugar during intense exercise, especially if also taking diabetes medications. Our fitness coaching provides exercise programs appropriate for your level and monitors your progress.'
    //     }
    //   ]
    // },
    // {
    //   title: 'Pricing & Insurance',
    //   icon: FaDollarSign,
    //   color: 'success',
    //   questions: [
    //     {
    //       q: 'How much does the Fitnession program cost?',
    //       a: 'Our program pricing varies based on the medication prescribed and plan selected. Monthly costs typically range from $299-$599, which includes provider consultations, medication, lifestyle coaching, and ongoing support. We offer flexible payment plans and believe in transparent pricing with no hidden fees.'
    //     },
    //     {
    //       q: 'Does insurance cover GLP-1 medications for weight loss?',
    //       a: 'Coverage varies by insurance plan. Many plans cover GLP-1 medications for diabetes (Ozempic, Mounjaro) but not always for weight loss (Wegovy, Zepbound). We can provide documentation to help you seek reimbursement from your insurance. Some patients use HSA/FSA funds for our program.'
    //     },
    //     {
    //       q: 'Are there any hidden fees?',
    //       a: 'No. Your monthly membership includes everything: provider consultations, medication, shipping, coaching, and support. There are no enrollment fees, hidden charges, or surprise costs. The price you see is the price you pay.'
    //     },
    //     {
    //       q: 'What is your refund policy?',
    //       a: 'We offer a 30-day money-back guarantee for new members. If you are not satisfied with the program within the first 30 days, contact us for a full refund of your membership fee. Medication costs may not be refundable once dispensed, as they cannot be restocked.'
    //     },
    //     {
    //       q: 'Can I cancel my membership anytime?',
    //       a: 'Yes, you can cancel your membership at any time with no cancellation fees. We believe in earning your continued trust, not locking you into contracts. If you cancel, you will have access through the end of your current billing period.'
    //     }
    //   ]
    // },
    // {
    //   title: 'Medical & Provider Questions',
    //   icon: FaUserMd,
    //   color: 'primary',
    //   questions: [
    //     {
    //       q: 'Who are the healthcare providers at Fitnession?',
    //       a: 'Our medical team consists of licensed physicians (MDs/DOs), nurse practitioners (NPs), and physician assistants (PAs) who specialize in obesity medicine, endocrinology, and metabolic health. All providers are licensed in your state and have extensive experience with GLP-1 medications and weight management.'
    //     },
    //     {
    //       q: 'Are the consultations done in person or virtually?',
    //       a: 'All consultations are conducted virtually via secure video conferencing. This allows for convenient access to care from anywhere, flexible scheduling including evenings and weekends, and eliminates the need for travel. Our telehealth platform is HIPAA-compliant and easy to use.'
    //     },
    //     {
    //       q: 'Is my health information kept private?',
    //       a: 'Absolutely. We take your privacy seriously. All health information is protected under HIPAA regulations and stored securely. We never sell your data to third parties. You control who has access to your health information, and we only share with other providers at your request and with your consent.'
    //     },
    //     {
    //       q: 'What if I have a medical emergency?',
    //       a: 'For medical emergencies, always call 911 or go to your nearest emergency room. Fitnession is not an emergency medical service. For urgent but non-emergency concerns related to your treatment, you can message your care team 24/7 and will receive a response within a few hours.'
    //     },
    //     {
    //       q: 'Can Fitnession providers prescribe other medications?',
    //       a: 'Our providers focus on weight management and can prescribe GLP-1 medications, anti-nausea medications, and other treatments directly related to your weight loss journey. For other medical needs, we recommend consulting with your primary care physician or specialist.'
    //     }
    //   ]
    // },
    // {
    //   title: 'General Questions',
    //   icon: FaQuestionCircle,
    //   color: 'accent',
    //   questions: [
    //     {
    //       q: 'How is Fitnession different from other weight loss programs?',
    //       a: 'Fitnession combines FDA-approved GLP-1 medications with comprehensive lifestyle coaching through our Six Pillars approach. Unlike medication-only programs, we address nutrition, exercise, sleep, mental health, and habits. Unlike coaching-only programs, we provide medical treatment that significantly enhances results. Our integrated approach leads to sustainable, long-term success.'
    //     },
    //     {
    //       q: 'Do I need to follow a specific diet?',
    //       a: 'We do not prescribe a rigid diet plan. Instead, our nutrition coaches work with you to develop sustainable eating habits that fit your lifestyle, preferences, and cultural background. We emphasize protein-rich foods, vegetables, whole grains, and mindful eating. You will learn to make better choices without feeling deprived.'
    //     },
    //     {
    //       q: 'What if I have dietary restrictions or food allergies?',
    //       a: 'Our nutrition guidance is fully customizable. Whether you are vegetarian, vegan, gluten-free, kosher, halal, or have food allergies, our coaches will work with you to create a plan that meets your needs while supporting your weight loss goals.'
    //     },
    //     {
    //       q: 'How do I get my medication?',
    //       a: 'After your provider prescribes your medication, it is shipped directly to your home in discreet, temperature-controlled packaging. Shipping is included in your membership. Most patients receive their medication within 3-5 business days. You will receive tracking information and delivery notifications.'
    //     },
    //     {
    //       q: 'What states is Fitnession available in?',
    //       a: 'Fitnession is currently available in most US states. Our licensed providers are credentialed in multiple states to serve patients nationwide. During the assessment process, we will confirm availability in your state. We are continuously expanding our coverage.'
    //     },
    //     {
    //       q: 'How do I contact customer support?',
    //       a: 'You can reach our support team via: in-app messaging (available 24/7), email at support@fitnession.com, or phone during business hours. For clinical questions, you can message your care team directly through the app. We aim to respond to all inquiries within 24 hours.'
    //     }
    //   ]
    // }
  ];

  const getColorClasses = (color) => {
    const colors = {
      primary: {
        bg: 'bg-primary-50',
        border: 'border-primary-200',
        icon: 'text-primary-600',
        hover: 'hover:bg-primary-100'
      },
      success: {
        bg: 'bg-success-50',
        border: 'border-success-200',
        icon: 'text-success-600',
        hover: 'hover:bg-success-100'
      },
      accent: {
        bg: 'bg-accent-50',
        border: 'border-accent-200',
        icon: 'text-accent-600',
        hover: 'hover:bg-accent-100'
      }
    };
    return colors[color] || colors.primary;
  };

  // Create FAQ structured data from the questions
  const faqItems = faqCategories.flatMap(cat =>
    cat.questions.map(q => ({ question: q.question, answer: q.answer }))
  );
  const faqStructuredData = StructuredData.faqPage(faqItems);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <SEO {...PageSEO.faq} structuredData={faqStructuredData} />
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-primary-600 to-primary-800 py-16 overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 z-0">
          <img
            src={images.medical.telehealth}
            alt="FAQ"
            className="w-full h-full object-cover opacity-20"
          />
        </div>
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            backgroundSize: '30px 30px'
          }}></div>
        </div>

        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <FaQuestionCircle className="text-6xl text-white/80 mx-auto mb-6" />
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Frequently Asked Questions
          </h1>
          <p className="text-xl text-primary-100 max-w-2xl mx-auto">
            Everything you need to know about Fitnession programs, coaching, nutrition, and your fitness journey
          </p>
        </div>
      </section>

      {/* Quick Links */}
      <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 -mt-8 relative z-10">
        <div className="bg-white rounded-2xl shadow-xl p-6">
          <h2 className="text-lg font-semibold text-gray-900 mb-4 text-center">Jump to a topic:</h2>
          <div className="flex flex-wrap justify-center gap-3">
            {faqCategories.map((category, index) => {
              const colors = getColorClasses(category.color);
              return (
                <a
                  key={index}
                  href={`#category-${index}`}
                  className={`inline-flex items-center px-4 py-2 rounded-full ${colors.bg} ${colors.border} border ${colors.hover} transition-colors`}
                >
                  <category.icon className={`mr-2 ${colors.icon}`} />
                  <span className="text-sm font-medium text-gray-700">{category.title}</span>
                </a>
              );
            })}
          </div>
        </div>
      </section>

      {/* FAQ Categories */}
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="space-y-12">
          {faqCategories.map((category, categoryIndex) => {
            const colors = getColorClasses(category.color);
            return (
              <div key={categoryIndex} id={`category-${categoryIndex}`} className="scroll-mt-24">
                {/* Category Header */}
                <div className="flex items-center mb-6">
                  <div className={`w-12 h-12 rounded-xl ${colors.bg} flex items-center justify-center mr-4`}>
                    <category.icon className={`text-2xl ${colors.icon}`} />
                  </div>
                  <h2 className="text-2xl font-bold text-gray-900">{category.title}</h2>
                </div>

                {/* Questions */}
                <div className="space-y-3">
                  {category.questions.map((item, itemIndex) => (
                    <div
                      key={itemIndex}
                      className={`border rounded-xl overflow-hidden transition-all ${
                        isOpen(categoryIndex, itemIndex)
                          ? `${colors.border} ${colors.bg}`
                          : 'border-gray-200 bg-white hover:border-gray-300'
                      }`}
                    >
                      <button
                        onClick={() => toggleItem(categoryIndex, itemIndex)}
                        className="w-full px-6 py-4 text-left flex items-center justify-between"
                      >
                        <span className="font-medium text-gray-900 pr-4">{item.q}</span>
                        <span className={`flex-shrink-0 ${colors.icon}`}>
                          {isOpen(categoryIndex, itemIndex) ? (
                            <FaChevronUp className="text-lg" />
                          ) : (
                            <FaChevronDown className="text-lg" />
                          )}
                        </span>
                      </button>

                      {isOpen(categoryIndex, itemIndex) && (
                        <div className="px-6 pb-4">
                          <div className="border-t border-gray-200 pt-4">
                            <p className="text-gray-600 leading-relaxed">{item.a}</p>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* Still Have Questions CTA */}
      <section className="bg-gradient-to-r from-primary-600 to-success-600 py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">
            Still have questions?
          </h2>
          <p className="text-xl text-white/90 mb-8">
            Our team is here to help you on your weight loss journey
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/pricing"
              className="inline-flex items-center justify-center bg-white text-primary-600 px-8 py-4 rounded-lg hover:bg-gray-100 transition-all font-semibold shadow-lg"
            >
              View Programs
              <FaArrowRight className="ml-2" />
            </Link>
            <a
              href="mailto:support@fitnession.com"
              className="inline-flex items-center justify-center bg-white/10 backdrop-blur-sm border-2 border-white text-white px-8 py-4 rounded-lg hover:bg-white/20 transition-all font-semibold"
            >
              Contact Support
            </a>
          </div>
        </div>
      </section>

      {/* Quick Stats */}
      {/* <section className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl p-6 shadow-md text-center">
              <FaClock className="text-4xl text-primary-600 mx-auto mb-4" />
              <h3 className="text-xl font-bold text-gray-900 mb-2">5-Minute Assessment</h3>
              <p className="text-gray-600">Quick and easy eligibility check from home</p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md text-center">
              <FaUserMd className="text-4xl text-success-600 mx-auto mb-4" />
              <h3 className="text-xl font-bold text-gray-900 mb-2">Licensed Providers</h3>
              <p className="text-gray-600">Expert medical care and ongoing support</p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md text-center">
              <FaShieldAlt className="text-4xl text-accent-600 mx-auto mb-4" />
              <h3 className="text-xl font-bold text-gray-900 mb-2">30-Day Guarantee</h3>
              <p className="text-gray-600">Risk-free with our money-back promise</p>
            </div>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default FAQ;
